import * as React from 'react';
import { LocalForm, Control as Input } from 'react-redux-form';

import Notification from '../Notification/Notification';

interface Field {
  name: string;
  type?: 'section' | 'checkbox' | 'textarea' | 'file' | 'select' | string;
  step?: number;
  label?: string;
  placeholder?: string;
  filter?: (field: Field, state) => boolean;
}

interface Props {
  fields?: Field[];
  values?: any;
  type: string;
  handleSubmit?: Function;
  handleChange?: Function;
  hasButton?: boolean;
  buttonText?: string;
  disabled?: boolean;
  selectedIndex?: number;
  getDispatch?: Function;
  errors?: string[];
}

interface State {
  data: any;
}

export default class Form extends React.Component<Props, State> {
  static defaultProps = {
    fields: [],
    values: {},
    handleSubmit: () => {},
    handleChange: () => {},
    hasButton: true,
    buttonText: 'Submit',
    disabled: false,
    getDispatch: () => {},
    selectedIndex: -1,
    errors: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  renderInput = (field: Field) => {
    switch (field.type) {
      case 'section':
        return (
          <div className="form-section">
            <h4>{field.name}</h4>
          </div>
        );
      case 'checkbox':
        return (
          <Input.checkbox
            id={field.name}
            name={field.name}
            model={`.${field.name}`}
            disabled={this.props.disabled}
          />
        );
      case 'textarea':
        return (
          <Input.textarea
            id={field.name}
            name={field.name}
            model={`.${field.name}`}
            disabled={this.props.disabled}
          />
        );
      case 'file':
        return (
          <Input.file
            id={field.name}
            name={field.name}
            model={`.${field.name}`}
            disabled={this.props.disabled}
          />
        );
      case 'select':
        if (
          this.props.values === {} ||
          this.props.values[field.name] === undefined ||
          this.props.values[field.name].length === 0
        ) {
          return (
            <Notification type="default">No values could be found</Notification>
          );
        }
        return (
          <div className="select">
            <Input.select
              id={field.name}
              name={field.name}
              model={`.${field.name}`}
              disabled={this.props.disabled}
            >
              <option>
                {field.placeholder ? field.placeholder : 'Please select...'}
              </option>
              {this.props.values[field.name].map((row) => (
                <option
                  key={row.value}
                  disabled={row.disabled}
                  value={row.value}
                >
                  {row.subOption ? '- ' : ''}
                  {row.name}
                </option>
              ))}
            </Input.select>
          </div>
        );
      default:
        return (
          <Input
            id={field.name}
            name={field.name}
            type={field.type}
            model={`.${field.name}`}
            disabled={this.props.disabled}
            step={field.step}
          />
        );
    }
  };

  render() {
    const checkError = (field: string) =>
      this.props.errors.indexOf(field) !== -1 ? 'error' : '';

    return (
      <div
        className={`form${this.props.type ? ` form--${this.props.type}` : ''}`}
      >
        <LocalForm
          model={this.props.type}
          getDispatch={(dispatch) => {
            this.props.getDispatch(dispatch);
          }}
          onSubmit={(data) => {
            this.props.handleSubmit(data);
          }}
          onChange={(data) => {
            this.setState({ data });
            this.props.handleChange(data);
          }}
        >
          {this.props.fields.map(
            (field, index) =>
              (!field.filter || !field.filter(field, this.state)) && (
                <div
                  className={`field ${
                    this.props.selectedIndex === index ? 'is-active' : ''
                  } ${checkError(field.name)}`}
                  key={field.name}
                >
                  {field.label !== undefined && (
                    <label htmlFor={field.name}>{field.label}</label>
                  )}
                  {this.renderInput(field)}
                </div>
              ),
          )}
          {this.props.hasButton && (
            <div className="buttons is-right">
              <button className="is-primary" disabled={this.props.disabled}>
                {this.props.buttonText}
              </button>
            </div>
          )}
        </LocalForm>
      </div>
    );
  }
}
